import { useState } from "react";
import { Box, Container } from "@mui/material"
import { DownloadButton } from "./DownloadButton"
import { DownloadQuotationDialog } from "./DownloadQuotationDialog"

export const DownloadQuotation = () => {
    const [open, setOpen] = useState(false);
    return <Container maxWidth='xl' style={{ padding: 0 }}>
        <Box marginTop="5px">
            <DownloadButton setOpen={setOpen} />
            <DownloadQuotationDialog open={open} setOpen={setOpen} />
        </Box>
    </Container> 
}